function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 90.468,
  cy: 74.762,
  r: 3.46,
  fill: "#E4E7EC"
});
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 106.905,
  cy: 56.595,
  r: 2.595,
  fill: "#E4E7EC"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.397,
  cy: 56.595,
  r: 2.595,
  fill: "#E4E7EC"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 71.436,
  cy: 64.38,
  r: 1.73,
  fill: "#ACB5C2"
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 31.643,
  cy: 62.651,
  r: 1.73,
  fill: "#D4DAE1"
});
var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 54.135,
  cy: 71.301,
  r: 1.73,
  fill: "#748499"
});
var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 2.23,
  cy: 66.111,
  r: 1.73,
  fill: "#ACB5C2"
});
var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 204.357,
  cy: 57.429,
  r: 3.429,
  transform: "rotate(180 204.357 57.429)",
  fill: "#E4E7EC"
});
var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 188.071,
  cy: 75.429,
  r: 2.571,
  transform: "rotate(180 188.071 75.429)",
  fill: "#E4E7EC"
});
var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 273.786,
  cy: 75.429,
  r: 2.571,
  transform: "rotate(180 273.786 75.429)",
  fill: "#E4E7EC"
});
var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 223.214,
  cy: 67.714,
  r: 1.714,
  transform: "rotate(180 223.214 67.714)",
  fill: "#ACB5C2"
});
var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 262.643,
  cy: 69.428,
  r: 1.714,
  transform: "rotate(180 262.643 69.428)",
  fill: "#D4DAE1"
});
var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 240.357,
  cy: 60.857,
  r: 1.714,
  transform: "rotate(180 240.357 60.857)",
  fill: "#748499"
});
var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 291.786,
  cy: 66,
  r: 1.714,
  transform: "rotate(180 291.786 66)",
  fill: "#ACB5C2"
});
var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 150.5,
  cy: 40,
  r: 40,
  fill: "#E4E7EC"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M168.846 33.228l-5.338-.818-11.787-11.07 5.287 10.312s12.976 1.346 10.749 4.073c-.889 1.088-.744 3.1-5.718 7.7-2.7 2.498 3.31 12.188-.7 12.188-2.702 0-10.839-4.35-10.839-4.35l-11.613 4.35 22.452 22.451c12.903-3.612 23.226-13.548 27.484-26.193l-19.977-18.643z",
  fill: "#576373"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M168.086 32.843c1.675.388 2.319 2.455 1.16 3.618l-6.442 6.847c-.387.388-.644 1.034-.516 1.68l1.16 9.301c.129 1.68-1.546 2.843-3.092 2.197l-8.89-4.005c-.515-.259-1.288-.259-1.803 0l-8.89 4.005c-1.546.646-3.35-.517-3.092-2.197l1.159-9.301c.129-.517-.128-1.163-.515-1.68l-6.57-6.847c-1.16-1.292-.516-3.36 1.159-3.618l9.534-1.808c.515-.13 1.159-.517 1.417-1.034l4.767-8.268c.773-1.421 2.963-1.421 3.736 0L157.135 30c.258.517.773.905 1.417 1.034l9.534 1.808z",
  fill: "#fff"
});
function SvgGrayStarGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 294 80",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}
export default __webpack_public_path__ + "fonts/gray-star-graphic-bfeacfd2e91f726a5ebe3ed7e4155366.svg";
export { SvgGrayStarGraphic as ReactComponent };